<template>
  <div :class="['nav-containter']">
    <div
      v-for="(x, i) in tabs"
      :key="i"
      @click="clickItem(x, i)"
      :class="['nav-item', nowIndex == i ? 'active' : '']"
    >
      {{ x.paramName }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: Array,
  },
  data() {
    return {
      nowIndex: 0,
    };
  },
  methods: {
    clickItem(x, i) {
      this.nowIndex = i;
      this.$emit("tabChage", x);
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-containter {
  display: flex;
  border-bottom: 1px solid #f0f0f0;
  padding-left: 24px;
  .nav-item {
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51627d;
    line-height: 54px;
    cursor: pointer;
    margin-right: 32px;
  }
  .nav-item.active {
    color: #4983f5;
    border-bottom: 2px solid #4983f5;
  }
}
</style>